// extracted by mini-css-extract-plugin
export default {"containerInLine":"ProgressCircle_containerInLine__gjiMv","containerToColumn":"ProgressCircle_containerToColumn__JuNFM","description":"ProgressCircle_description__o4cOP"};